import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux"
import Signature from 'react-another-signature-pad';
import Moment from 'react-moment'
import classNames from 'classnames';

import { Field, reduxForm, change, reset } from 'redux-form';
import Modal from 'react-responsive-modal';

import agent from '../agent';

const renderError = ({ meta: { touched, error } }) => 
  touched && error ? <p className="form-error is-visible" id="uuid">{error}</p> : false 

const validate = {
			acceptConfirmation: value => value ? undefined : "You need to accept before submitting the form",
			signature: value => value ? undefined : "Your signature is required"
		}

class Confirmation extends Component {
	state = {
		selectedSignature : '',
		showSignatureModal: false,
		partialSignature: '',
		finishSignature: false,
		dateNow: ''		
	}
	
	handleChange = (data) => {
		const { setSignature } = this.props
		this.setState({ partialSignature: data });
		setSignature(data);
	}

	sendSignature = (e) => {
		this.setState({
			selectedSignature: this.state.partialSignature,
			dateNow: new Date()
		})
		this.onCloseModal()
	}

	onOpenModal = (e) => {
		e.preventDefault()
		this.setState({
			showSignatureModal: true
		})
	}

	onCloseModal = (e) => {
		this.setState({
			showSignatureModal: false
		})
	}

	async submit (values, dispatch, props) {
		this.setState({ loading: true })
		console.log('submit-confirm')
		return props.onSubmit(props.handleSubmit)
	}

	render() {
		const { handleSubmit, errors, errorMessage, previousPage, nextPage, pristine, submitting, location, artist, currentState, checkin, flag, flagterms, enableButton, projectDetails, clientDetails } = this.props
		const publicToken = new URLSearchParams(location.search).get('token')
		const style = {
			width: '100%', 
			minWidth: '450px',
			height: '300px',
			backgroundColor: 'rgb(255,255,255)',
			border: '1px solid #e2e2e2'
		}
		console.log('checkin', currentState)
		return (
			<form onSubmit={handleSubmit} className="checking-confirmation-form">

				<section className="section gray-bg">
					<div className="grid-x align-center">
								<div className="small-12 medium-10 large-8 cell">

									<div className="text-center">
										{
											flagterms ?
											<p>Thank you for filling out the information, 
											please read the terms below, click sign and apply your signature and then 
											SUBMIT to finish your application
											</p> : <p>Thank you for filling out the information, click SUBMIT to finish now</p>
										}
									</div>
									<div className="row">
									{
									flagterms ?
										<div className="small-12 medium-8 medium-centered column accept-confirmation">
												<div className="custom-checkbox">
					                <p>{projectDetails.terms_and_conditions}</p>
					                <Field
					                  className="styled-checkbox"
					                  name="accept_confirmation"
					                  id="accept_confirmation"
					                  component="input"
					                  type="checkbox"
					                />
					                <label htmlFor="accept_confirmation" id="accept-confirmation-label">
					                	I <span className="white-text">{artist.first_name}</span> <span className="white-text">{artist.last_name}</span>{ artist.at2_agency_name !== 'Freelance' && <span> of <span className="white-text">{artist.at2_agency_name}</span></span>}, 
					                	agree that the information I have provided is true and accurate and to the best of my knowledge. 
										    		I agree to notify <span className="white-text">{
										    				clientDetails.client
										    				? clientDetails.client.name
										    				: clientDetails 
										    					? clientDetails.name
										    					: checkin.companies[0].name
										    				// currentState.clientDetails.client.default_company_details.name || "Company Name"
										    			}</span> immediately if any of the availability or other information I provided should change 
										    		between now and the shooting date.
					                </label>
					              </div>

					              <Field name="accept_confirmation" validate={[validate.acceptConfirmation]} component={renderError} />
										</div>
									: <span/>
									}
									</div>
								  

								    <Modal  
											open={this.state.showSignatureModal} 
											onClose={this.onCloseModal} little>
											<p className="reveal-title">PLEASE SIGN YOUR NAME IN THE BOX BELOW</p>

								      <Signature style={style} mimeType="image/png" onEnd={this.handleChange} />
								      
								      <div className="clearfix"></div>
								      <button 
								      	className="button float-left" 
								      	onClick={this.onCloseModal}>Cancel</button>
								      <button 
								      	className="button float-right" 
								      	onClick={this.sendSignature}>Proceed</button>
								    </Modal>
								</div>
					</div>
				</section>

				<section className="section">
					<div className="grid-x align-center">
						{
							flag ?
							<div className="small-10">

								<div className="row">
									<div className="small-12 column text-center">

									<p className="gray-text">Please click to sign your name</p>

									<Field name="signature" validate={[validate.signature]} component={renderError} />

									<button 
										className="button primary sign-button" 
										onClick={this.onOpenModal}>
										Sign</button> 

									{
										this.state.selectedSignature 
										? <div className="final-signature"><img src={this.state.selectedSignature} alt="" /> <div className="timestamp"><Moment>{this.state.dateNow}</Moment></div></div>
										: ''
									}
									</div>
								</div>

								{ errorMessage && <p className="error-message red-text text-center"><i className="fa fa-exclamation-circle"></i> {errorMessage || "Sorry Something went wrong!" }</p>}
							</div> : <p></p>
						}
						<div className="small-12 cell text-center">
							{
					            previousPage &&
					            <button 
					              className="button primary previous" 
					              type="button" 
					              onClick={previousPage} >Previous</button>
				          	}

				          	{
					            nextPage 
					            ? <button className="button primary next" type="submit">Next</button>
					            : <button className="button primary" 
													type="submit" 
													disabled={enableButton || pristine || submitting}>
														{	submitting ? 
																publicToken ? 'Processing...'
																	: 'Processing your Check-in...' 
																: 'Submit' }
												</button>
				          	}
						</div>
					</div>
				</section>
			</form>
		)
	}
}




export default reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  onSubmitSuccess: (result, dispatch) => dispatch(reset('checkinWizard'))
  // validate
})(Confirmation)


// WEBPACK FOOTER //
// ./src/components/Confirmation.js